import { FaEnvelope, FaPhone } from "react-icons/fa";
import { LuCheckCheck } from "react-icons/lu";
import successStory from "../../common/images/success-story.png";
import { useState } from "react";
import { motion } from "framer-motion";

const BusinessInfo = () => {
  const [selected, setSelected] = useState(1);

  const data = [
    {
      id: 1,
      title: "The Great Mission",
      text: "Our mission is to empower businesses with innovative and scalable solutions. We aim to create a seamless digital experience that drives growth and enhances customer satisfaction.",
    },
    {
      id: 2,
      title: "The Great Vision",
      text: "We envision a future where technology bridges the gap between challenges and opportunities. Our goal is to become a global leader in software development, setting new standards of excellence.",
    },
    {
      id: 3,
      title: "The Great Promise",
      text: "We promise to deliver value-driven solutions with a customer-first approach. Your success is our success, and we are committed to providing reliable, efficient, and tailored solutions for your business.",
    },
  ];
  return (
    <div className="max-w-7xl mx-auto px-4 py-10 grid grid-cols-1 md:grid-cols-2 gap-8">
      {/* Left Side - Images and Experience */}
      <div className="size-full">
        <img
          src={successStory}
          alt="Team working"
          className="size-fullobject-cover rounded-lg"
        />
      </div>

      {/* Right Side - Text Content */}
      <div>
        <p className="text-webOranage font-semibold">/ Who are we /</p>
        <h2 className="small:text-3xl text-2xl font-bold text-gray-800 mt-2">
          Building Success Together,
        </h2>
        <h2 className="small:text-3xl text-2xl font-bold text-gray-800">
          One Solution at a Time
        </h2>
        <p className="text-gray-600 mt-4 small:text-[14px] text-[12px]">
          <b> At Binary Ops Pvt Ltd </b>, we believe in turning ideas into
          reality. With over <b>12 years of experience </b>, we have been at the
          forefront of delivering innovative and tailored software solutions.
          Our team of experts is dedicated to helping businesses thrive in the
          digital landscape by providing cutting-edge technology and strategic
          insights.
        </p>

        {data.map((item) => (
          <div key={item.id}>
            <div
              className={`p-3 mt-2 font-semibold cursor-pointer transition duration-300 ${
                selected === item.id
                  ? "bg-secondary text-white rounded-t-md"
                  : "bg-gray-100 text-gray-800 rounded-md"
              }`}
              onClick={() => setSelected(selected === item.id ? null : item.id)}
            >
              {`${item.id < 10 ? "0" + item.id : item.id}. ${item.title}`}
            </div>

            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={
                selected === item.id
                  ? { height: "auto", opacity: 1 }
                  : { height: 0, opacity: 0 }
              }
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              className="overflow-hidden"
            >
              <p className="p-3 bg-gray-100 text-gray-700">{item.text}</p>
            </motion.div>
          </div>
        ))}

        <div className="mt-4 space-y-2">
          <p className="flex items-center gap-2 text-gray-600">
            <LuCheckCheck className="text-secondary font-bold size-6" /> Explore
            job roles based on your expertise
          </p>
          <p className="flex items-center gap-2 text-gray-600">
            <LuCheckCheck className="text-secondary font-bold size-6" />{" "}
            Discover new opportunities aligned with your skills
          </p>
        </div>

        <div className="mt-6 flex flex-col md:flex-row gap-6">
          <div className="flex items-center gap-2 text-secondary font-semibold">
            <FaEnvelope />
            <span>Email:info@binaryops.co</span>
          </div>
          <div className="flex items-center gap-2 text-webOranage font-semibold">
            <FaPhone />
            <span>+44 1293730103</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessInfo;
